var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',{staticClass:"w-100"},[(_vm.loadingState)?_c('loader'):_c('data-table',{staticClass:"w-100",attrs:{"tableHeaders":_vm.headerArray,"tableData":_vm.dataArray},on:{"editHandler":_vm.editData}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }